/* Countdown Component https://www.fareez.info/blog/countdown-timer-using-vuejs/
*/

<template>
  <div class="grid xs:grid-cols-4 text-center text-white gap-5 md:gap-10">
    <div class="grid grid-rows-2 gap-y-3">
      <p class="text-4xl lg:text-8xl">{{ days }}</p>
      <p class="text-xs">Days</p>
    </div>

    <div class="grid grid-rows-2 gap-y-3">
      <p class="text-4xl lg:text-8xl">{{ hours }}</p>
      <p class="text-xs">Hours</p>
    </div>

    <div class="grid grid-rows-2 gap-y-3">
      <p class="text-4xl lg:text-8xl">{{ minutes }}</p>
      <p class="text-xs">Minutes</p>
    </div>

    <div class="grid grid-rows-2 gap-y-3">
      <p class="text-4xl lg:text-8xl">{{ seconds }}</p>
      <p class="text-xs">Seconds</p>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000);
    }, 50);
  },

  data() {
    return {
      now: Math.trunc(new Date().getTime() / 1000),
      date: Math.trunc(Date.parse("August 21, 2021 11:00") / 1000)
    };
  },

  computed: {
    seconds() {
      return (this.date - this.now) % 60;
    },

    minutes() {
      return Math.trunc((this.date - this.now) / 60) % 60;
    },

    hours() {
      return Math.trunc((this.date - this.now) / 60 / 60) % 24;
    },

    days() {
      return Math.trunc((this.date - this.now) / 60 / 60 / 24);
    }
  }
};
</script>
